/**
 * @generated SignedSource<<2a3973c969a58342e4fb6970f15c5773>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type OrderStatusType = "ClosedByAdmin" | "HasBillingDetails" | "HasCart" | "HasPaymentDetails" | "PaymentInProcess" | "PaymentReceived" | "Purchased" | "PurchasedAwaitingAccount" | "Transient";
import { FragmentRefs } from "relay-runtime";
export type invoiceEmailActions_OrderFragment$data = {
  readonly customerDetails: {
    readonly invoiceEmail: string;
  } | null;
  readonly id: string;
  readonly invoiceData: {
    readonly invoiceNumber?: string;
  };
  readonly status: OrderStatusType;
  readonly " $fragmentType": "invoiceEmailActions_OrderFragment";
};
export type invoiceEmailActions_OrderFragment$key = {
  readonly " $data"?: invoiceEmailActions_OrderFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"invoiceEmailActions_OrderFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "invoiceEmailActions_OrderFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Billing_CustomerDetails",
      "kind": "LinkedField",
      "name": "customerDetails",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "invoiceEmail",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "invoiceData",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "invoiceNumber",
              "storageKey": null
            }
          ],
          "type": "CreatedInvoiceData",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "1567c3903c8caf7d80dc257ed0203ed3";

export default node;
